export const checkinAllStatusUpdate = data => {
  return [...data].map(item => ({
    ...item,
    status: 'checkInSubmitted',
  }))
}
